import { render, staticRenderFns } from "./ModifyKeywordPopup.vue?vue&type=template&id=15f772ac&"
import script from "./ModifyKeywordPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyKeywordPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports